import {Component, OnInit} from '@angular/core';
import {KfChartsService} from '../../../../services/kf-charts.service';
import {Master} from '../../../../../admin/models/master.interface';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {CostChartInfo} from '../../../../models/cost-chart-info.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../../utils/filters-utils';
import {CostChartData} from '../../../../models/cost-chart-data.interface';

@Component({
  selector: 'app-cost-benchmark',
  templateUrl: './cost-benchmark.component.html',
  styleUrls: ['./cost-benchmark.component.scss']
})
export class CostBenchmarkComponent implements OnInit {

  text!: string;
  subtitle!: string;
  data!: CostChartInfo;
  years!: number[];
  collectionStreams!: Master[];
  currentRoute?: string;
  chartType!: string;

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
    this.currentRoute = router.getCurrentNavigation()?.extractedUrl.toString();
  }


  ngOnInit(): void {
    this.chartType = this.currentRoute?.includes('operational') ? 'Operational' : 'Overhead';
    this.text = this.chartType + ' costs';
    this.kfChartsService.getCollectionStreams().subscribe(data => this.collectionStreams = data);
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.kfChartsService.getYears('cost', 'WEEE_SYSTEM_SCHEMA')
        .subscribe(data => {
          this.years = data;
          if (!search.startYear) {
            search.startYear = data[0];
          }
          this.kfChartsService.getCostBenchmarkDatasets(search, this.chartType).subscribe(datasets => {
              if (datasets > 3) {
                this.kfChartsService.getCostBenchmark(search, this.chartType)
                  .subscribe(response => {
                    this.data = response;
                    this.subtitle = search.startYear + ' (€/ton) ';
                  });
              } else {
                this.data = {
                  weeeSystemId: -1,
                  weeeSystemName: '',
                  chartData: [] as CostChartData[]
                } as CostChartInfo;
                this.subtitle = 'To keep confidentiality, only charts with more than 3 data sets can be displayed, apologies for the inconvenience';
              }
            }
          );
        });
    });
  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});
  }

}
